import React from 'react';
import { ICellRendererParams } from '@trackman/baseball-shared-components';
import { IReviewDataRow } from 'interfaces/review/IReviewDataRow';

const defensivePlayerRenderer = (data: ICellRendererParams<any, IReviewDataRow>) => {
  return <div>{data.value?.nameRef || 'Undefined'}</div>;
};

export default defensivePlayerRenderer;
